<template>
  <section class="text-dark bg-light">
    <div class="container mt-0">
      <div class="row mx-md-auto col-md-8 py-5">
        <div class="col-12 my-5">
          <h2 class="mb-5 text-center" data-aos="fade-up" data-aos-delay="500">Sie suchen das Besondere?</h2>
          <p data-aos="fade-up" data-aos-delay="500">Mit DJ MEDI wird Ihr privates oder betriebliches Fest zu einem unvergesslichen Event.</p>
          <p data-aos="fade-up" data-aos-delay="500">Als erfahrener Dienstleister begleite ich Sie stets professionell, zuverlässig und freundlich mit meiner Musik durch den Abend von Anfang an bis Open End.</p>
          <p data-aos="fade-up" data-aos-delay="500">Publikumsorientierte Musikauswahl für alle Generationen, eine niveauvolle Moderation, eine auf Raumgröße und Ihre Gästezahl abgestimmte Musik- und LED Lichtanlage, eine angenehme Lautstärke und stets faire Preise. Der Höhepunkt des Abends ist dann Eure Party mit tanzbarer Musik, ausgelassener Stimmung und tanzenden Gästen.</p>
          <p class="mt-5" data-aos="fade-up" data-aos-delay="500">Nutzen Sie meine langjährige Erfahrung und Qualität bei der Planung und Durchführung von:</p>
          <ul>
            <li data-aos="fade-up" data-aos-delay="500">Hochzeiten</li>
            <li data-aos="fade-up" data-aos-delay="500">Firmenevents (Eröffnungsfeiern, Jubiläen, Jahresabschlüsse, Weihnachtsfeiern etc.)</li>
            <li data-aos="fade-up" data-aos-delay="500">Geburtstage und Familienfeste</li>
            <li data-aos="fade-up" data-aos-delay="500">Stadtfeste, Dorffeste, Vereinsfeste etc.</li>
            <li data-aos="fade-up" data-aos-delay="500">Discotheken (Ü30 und Ü40 Partys, Rockabende etc.)</li>
            <li data-aos="fade-up" data-aos-delay="500">Faschings- und Mottopartys aller Art</li>
          </ul>
          <div class="row align-items-center">
            <div class="col-lg-7">
              <p class="mt-5"  data-aos="fade-up" data-aos-delay="500">Ich stehe Ihnen dabei uneingeschränkt zur Verfügung.</p>
              <p data-aos="fade-up" data-aos-delay="500">Fragen Sie einfach an, ich freue mich auf Ihre Anforderung!</p>
              <p class="mt-5"  data-aos="fade-up" data-aos-delay="500">Freundliche Grüße</p>
              <p data-aos="fade-up" data-aos-delay="500">DJ Medi</p>
            </div>
            <div class="col-lg-5 text-center">
              <img src="@/assets/img/medi-sakko.jpeg" class="col-8 col-md-12 mt-5 mt-xl-0">
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

</script>

<style scoped>
</style>